import React, { useState, useEffect } from 'react';
import './EngineeringCollege.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

import {
  FaCogs,
  FaBrain,
  FaLaptopCode,
  FaBroadcastTower,
  FaHardHat,
  FaUniversity,
} from 'react-icons/fa';

const EngineeringCollege = () => {
  const [activeSection, setActiveSection] = useState('about');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleSectionClick = (sectionId) => {
  setActiveSection(sectionId);
  setIsMobileSidebarOpen(false);

  // Update URL hash
  window.history.pushState(null, "", `#${sectionId}`);
};


 useEffect(() => {
  const hash = window.location.hash.replace("#", "");

  if (hash && sections.some(s => s.id === hash)) {
    setActiveSection(hash);

    setTimeout(() => {
      const element = document.getElementById(`engc-section-${hash}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300);
  } else {
    setActiveSection("about");
  }

}, []);




  const departments = [
    {
      id: 1,
      name: 'Artificial Intelligence',
      college: 'College of Engineering',
      icon: FaBrain,   // ✅ NO JSX
      route: '/academics/ai',
      color: '#0B3C5D'
    },
    {
      id: 2,
      name: 'Computer Science & Engineering',
      college: 'College of Engineering',
      icon: FaLaptopCode,
      route: '/academics/cse',
      color: '#0B3C5D'
    },
    {
      id: 3,
      name: 'Electronics & Communication Engineering',
      college: 'College of Engineering',
      icon: FaBroadcastTower,
      route: '/academics/electronics',
      color: '#0B3C5D'
    },
    {
      id: 4,
      name: 'Civil Engineering',
      college: 'College of Engineering',
      icon: FaHardHat,
      route: '/academics/civil',
      color: '#0B3C5D'
    },
    {
      id: 5,
      name: 'Mechanical Engineering',
      college: 'College of Engineering',
      icon: FaCogs,
      route: '/academics/mechanical',
      color: '#0B3C5D'
    },
    {
      id: 6,
      name: 'Humanities & Basic Sciences',
      college: 'College of Engineering',
      icon: FaUniversity,
      route: '/academics/humanities-basic-sciences',
      color: '#0B3C5D'
    }
  ]

  const sections = [
    { id: 'about', label: 'About' },
    { id: 'principal', label: 'Principal' },
    { id: 'departments', label: 'Departments' },
    { id: 'events', label: 'Events & Achievements' },
    { id: 'administration', label: 'Administration' }
  ];

  const navigate = useNavigate();

  const handleDepartmentClick = (dept) => {
    if (dept.external) {
      window.open(dept.route, "_blank", "noopener,noreferrer");
    } else {
      navigate(dept.route); // ✅ internal routing
    }
  };


  return (
    <>
      <Navbar />
      <div className="engc-page-container">
        {/* Banner */}
        <div className="engc-banner">
          <img
            src="/campuslife/college/engineeringBuilding.JPG"
            alt="Engineering College"
            className="engc-banner-image"
          />
          <div className="engc-banner-overlay">
            <h1 className="engc-banner-title">Engineering College</h1>
          </div>
        </div>

        <div className="engc-content-wrapper">
          {/* Mobile Sidebar Toggle */}
          <button
            className="engc-mobile-sidebar-toggle"
            onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
          >
            {isMobileSidebarOpen ? '✕' : '☰'} Navigation
          </button>

          {/* Vertical Navigation Sidebar */}
          <aside className={`engc-sidebar ${isMobileSidebarOpen ? 'engc-sidebar-open' : ''}`}>
            <div className="engc-sidebar-header">
              <h3>Quick Links</h3>
            </div>
            <nav className="engc-sidebar-nav">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`engc-nav-item ${activeSection === section.id ? 'engc-nav-item-active' : ''}`}
                  onClick={() => handleSectionClick(section.id)}
                >
                  {section.label}
                </button>
              ))}
            </nav>
          </aside>

          {/* Main Content Area */}
          <main className="engc-main-content">
            {/* About Section */}
            {activeSection === 'about' && (
              <section id="engc-section-about" className="engc-content-section">
                <h2 className="engc-section-title">College of Engineering</h2>

                <div className="engc-section-card">

                  {/* ===== Vice Chancellor Card (TOP) ===== */}
                  <div className="cos-vc-card">
                    <img
                      src="/person/vicechancellor2.JPG"
                      alt="Prof. V. Venkata Basava Rao"
                      className="cos-vc-image"
                    />

                    <div className="cos-vc-info">
                      <h3>Prof. V. Venkata Basava Rao</h3>
                      <p className="cos-vc-position">Hon'ble Vice Chancellor</p>
                      <p className="cos-vc-sub">Rayalaseema University</p>

                      <Link
                        to="/about/vc-message"
                        className="cos-vc-btn"
                      >
                        View Message
                      </Link>
                    </div>
                  </div>

                  {/* ===== About Text ===== */}
                  <p className="engc-section-text">
                    The College of Engineering at Rayalaseema University stands as a beacon of
                    technical excellence and innovation. Established with a mission to produce
                    highly competent engineers and technologists, the college offers quality
                    education in emerging and core engineering disciplines.
                  </p>

                  <p className="engc-section-text">
                    With state-of-the-art laboratories, modern infrastructure, and highly
                    qualified faculty, the college nurtures technical expertise, research
                    culture, and entrepreneurial thinking among students to meet global
                    industry standards.
                  </p>

                  <div className="engc-highlights">
                    <h3 className="engc-highlights-title">Key Highlights:</h3>
                    <ul className="engc-highlights-list">
                      <li>6 specialized engineering departments with UG & PG programmes</li>
                      <li>Modern laboratories with advanced equipment</li>
                      <li>Highly qualified and experienced faculty</li>
                      <li>Strong industry linkages and internships</li>
                      <li>Active research and innovation ecosystem</li>
                      <li>Excellent placement support</li>
                      <li>Technical clubs, hackathons & project expos</li>
                      <li>Incubation and entrepreneurship support</li>
                    </ul>
                  </div>

                </div>
              </section>
            )}


            {/* Principal Section */}
            {activeSection === 'principal' && (
              <section id="engc-section-principal" className="engc-content-section">
                <h2 className="engc-section-title">Principal</h2>
                <div className="engc-section-card engc-principal-card">
                  <div className="engc-principal-header">
                    <div className="engc-principal-photo">
                      <img src="/mathematics/putcha1.jpg" alt="Principal" />
                    </div>
                    <div className="engc-principal-info">
                      <h3 className="engc-principal-name">Prof. Venkata Sundaranand Putcha </h3>
                      <p className="engc-principal-designation">Principal, Engineering College</p>
                      <p className="engc-principal-qualification">M.Sc., Ph.D.</p>
                      <p className="engc-principal-specialization"><strong>Specialization:</strong> Cryptanalysis</p>
                      <div className="engc-principal-contact">
                        <p><strong>Email:</strong> <a href="mailto:anand_putcha@yahoo.com">anand_putcha@yahoo.com</a></p>
                        <p><strong>Mobile:</strong> +91-9848226855</p>
                      </div>
                    </div>
                  </div>
                  <div className="engc-principal-message">
                    <h4>Message from Principal</h4>
                    <p>
                      Welcome to the College of Engineering at Rayalaseema University. It gives me immense pleasure to lead this
                      prestigious institution that has been shaping future engineers and technologists. Our college is committed
                      to providing world-class technical education that combines theoretical knowledge with practical skills.
                    </p>
                    <p>
                      We believe in fostering innovation, creativity, and entrepreneurship among our students. With strong industry
                      connections, modern infrastructure, and dedicated faculty, we prepare our students not just for jobs, but for
                      creating jobs and leading technological advancements. I invite you to be part of our engineering community and
                      contribute to building a better tomorrow.
                    </p>
                  </div>
                </div>
              </section>
            )}

            {/* Departments Section */}
            {activeSection === 'departments' && (
              <section id="engc-section-departments" className="engc-content-section">
                <h2 className="engc-section-title">Departments</h2>

                <div className="engc-departments-grid">
                  {departments.map((dept, index) => {
                    const IconComponent = dept.icon;

                    return (
                      <div key={index} className="engc-department-card">

                        <div className="engc-department-icon">
                          <IconComponent />
                        </div>

                        <div className="engc-department-info">
                          <h3 className="engc-department-name">{dept.name}</h3>
                          <p className="engc-department-college">{dept.college}</p>

                          {/* ✅ VIEW BUTTON */}
                          <button
                            className="engc-department-btn"
                            onClick={() => handleDepartmentClick(dept)}
                          >
                            View
                          </button>
                        </div>

                      </div>
                    );
                  })}
                </div>
              </section>
            )}

            {/* Events & Achievements Section */}
            {activeSection === 'events' && (
              <section id="engc-section-events" className="engc-content-section">
                <h2 className="engc-section-title">Events & Achievements</h2>
                <div className="engc-events-grid">
                  <div className="engc-event-card">
                    <div className="engc-event-type">Hackathon</div>
                    <h3 className="engc-event-title">National Level Hackathon 2024</h3>
                    <p className="engc-event-date">March 10-12, 2024</p>
                    <p className="engc-event-description">
                      The college successfully organized a 48-hour national level hackathon with participation from over
                      200 students from various engineering colleges, focusing on innovative solutions for real-world problems.
                    </p>
                  </div>

                  <div className="engc-event-card">
                    <div className="engc-event-type">Achievement</div>
                    <h3 className="engc-event-title">Smart India Hackathon Winners</h3>
                    <p className="engc-event-date">February 2024</p>
                    <p className="engc-event-description">
                      Students from the Computer Science department won first prize at the Smart India Hackathon,
                      developing an innovative AI-based solution for agricultural monitoring and crop prediction.
                    </p>
                  </div>

                  <div className="engc-event-card">
                    <div className="engc-event-type">Conference</div>
                    <h3 className="engc-event-title">International Conference on Emerging Technologies</h3>
                    <p className="engc-event-date">January 20-22, 2024</p>
                    <p className="engc-event-description">
                      The college hosted an international conference featuring keynote speakers from IITs, NITs, and
                      international universities, with over 150 research papers presented across various engineering domains.
                    </p>
                  </div>

                  <div className="engc-event-card">
                    <div className="engc-event-type">Achievement</div>
                    <h3 className="engc-event-title">Patent Filing Success</h3>
                    <p className="engc-event-date">December 2023</p>
                    <p className="engc-event-description">
                      Faculty and students from multiple departments filed 15 patents for innovative engineering solutions
                      in areas including IoT, renewable energy, and smart systems.
                    </p>
                  </div>

                  <div className="engc-event-card">
                    <div className="engc-event-type">Workshop</div>
                    <h3 className="engc-event-title">Industry 4.0 Workshop Series</h3>
                    <p className="engc-event-date">November 2023</p>
                    <p className="engc-event-description">
                      A comprehensive workshop series on Industry 4.0 technologies including IoT, AI/ML, Robotics, and
                      Cloud Computing was conducted with industry experts from leading tech companies.
                    </p>
                  </div>

                  <div className="engc-event-card">
                    <div className="engc-event-type">Competition</div>
                    <h3 className="engc-event-title">Tech Fest Innovation Challenge</h3>
                    <p className="engc-event-date">October 2023</p>
                    <p className="engc-event-description">
                      The annual tech fest featured various competitions including robotics, coding, circuit design, and
                      project exhibitions, with participation from over 500 students from different colleges.
                    </p>
                  </div>
                </div>
              </section>
            )}

            {/* Administration Section */}
            {activeSection === 'administration' && (
              <section id="engc-section-administration" className="engc-content-section">
                <h2 className="engc-section-title">
                  Non-Teaching Staff
                </h2>

                <div className="engc-section-card">
                  <div className="engc-admin-grid">

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Sri. Abdul Malik</h4>
                      <p className="engc-admin-member-designation">Senior Assistant</p>
                      <p className="engc-admin-member-affiliation">Principal Office</p>
                      <p className="engc-admin-member-contact">
                        9618153874  abdulmalikjm@gmail.com
                      </p>
                    </div>

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Sri. C. Venkata Swamy</h4>
                      <p className="engc-admin-member-designation">Office Assistant</p>
                      <p className="engc-admin-member-affiliation">Principal Office</p>
                      <p className="engc-admin-member-contact">
                        9441733521  venkataswamy1971@gmail.com
                      </p>
                    </div>

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Sri. V. Varada Rajulu</h4>
                      <p className="engc-admin-member-designation">Office Assistant</p>
                      <p className="engc-admin-member-affiliation">Principal Office</p>
                      <p className="engc-admin-member-contact">
                        9949215329 vvrajusai@gmail.com
                      </p>
                    </div>

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Sri. N. Venkateswarlu</h4>
                      <p className="engc-admin-member-designation">Office Assistant</p>
                      <p className="engc-admin-member-affiliation">Exam Section, RUCE</p>
                      <p className="engc-admin-member-contact">
                        9441280266   venkatgpl1978@gmail.com
                      </p>
                    </div>

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Sri. P. Venkoba Rao</h4>
                      <p className="engc-admin-member-designation">Office Sub-Ordinate</p>
                      <p className="engc-admin-member-affiliation">Exam Section, RUCE</p>
                      <p className="engc-admin-member-contact">
                        9963172696   venkobap1971@gmail.com
                      </p>
                    </div>

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Smt. A. Krishna Veni</h4>
                      <p className="engc-admin-member-designation">Office Sub-Ordinate</p>
                      <p className="engc-admin-member-affiliation">Principal Office</p>
                      <p className="engc-admin-member-contact">
                        8522856088
                      </p>
                    </div>

                    <div className="engc-admin-member">
                      <h4 className="engc-admin-member-name">Sri. M. Muni Swamy</h4>
                      <p className="engc-admin-member-designation">Office Sub-Ordinate</p>
                      <p className="engc-admin-member-affiliation">Principal Office</p>
                      <p className="engc-admin-member-contact">
                        9390123085
                      </p>
                    </div>

                  </div>
                </div>
              </section>
            )}

          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EngineeringCollege;
